import {toast} from 'react-toastify';

export const copyText = (text) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(`Скопировано!`, {});
    })
    .catch((err) => {
      console.log('Something went wrong', err);
    });
};
